import { Dialog, DialogContent } from '@/components/ui/dialog';
import AuthFlow from './AuthFlow';

interface AuthModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  prefillEmail?: string;
}

export default function AuthModal({ open, onOpenChange, prefillEmail }: AuthModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md p-8 bg-card border-border">
        <AuthFlow
          compact
          prefillEmail={prefillEmail}
          onSuccess={() => onOpenChange(false)}
        />
      </DialogContent>
    </Dialog>
  );
}
